import { LOGIN_REDIRECT_DEEP_LINK_HASH, LocalStorage } from "@suse-o11y/local-storage";
import { isUserSessionKey } from "@suse-o11y/local-storage/user-session-key";

import { CSRF_TOKEN_COOKIE } from "../generic/request";

export function logout(): void {
	LocalStorage.filterItems((key) => !isUserSessionKey(key));
	// This cannot be a fetch call because of the way this may (depending on the authentication mechanism)
	// the response may be a redirect to complete the logout
	location.href = "/logout";
}

export function expireCSRFCookieAndRedirectToLoginPage(): void {
	document.cookie = `${CSRF_TOKEN_COOKIE}=invalid; expires=Thu, 01 Jan 1970 00:00:01 GMT`;
	LocalStorage.setItem(LOGIN_REDIRECT_DEEP_LINK_HASH, location.hash);
	location.href = "/login.html";
}
